export const roomType = [
    'Primary Bedroom',
    'Bedroom',
    'Primary Bathroom',
    'Bathroom',
    'Kitchen',
    'Additional Kitchen',
    'Atrium',
    'Basement',
    'Bonus Room',
    'Conservatory',
    'Converted Garage',
    'Den',
    'Dining Room',
    'Exercise Room',
    'Family Room',
    'Foyer',
    'Game Room',
    'Great Room',
    'Gym',
    'Laundry',
    'Library',
    'Living Room',
    'Loft',
    'Media Room',
    'Office',
    'Sauna',
    'Screened Patio/Porch',
    'Storage',
    'Sun',
    'Wine',
    'Workshop'
];

export const roomLevel = ['Main', 'First', 'Second', 'Third', 'Lower', 'Upper'];

export const roomFeatures = [
    'Bar',
    'Bar Ice Maker',
    'Beamed Ceilings',
    'Bidet',
    'Bookcases',
    'Breakfast Area',
    'Breakfast Bar',
    'Butler Pantry',
    'Cathedral Ceiling(s)',
    'Cedar Closet(s)',
    'Ceiling Fan(s)',
    'Center Island',
    'Central Vacuum',
    'Chandelier',
    'Coffered Ceiling(s)',
    'Counter-Corian',
    'Counter-Granite',
    'Counter-Laminate',
    'Counter-Quartz',
    'Counter-Stone',
    'Counter-Tile',
    'Country Kitchen',
    'Crown Molding',
    'Dining Area',
    'Dry Bar',
    'Dual Vanity',
    'Dumbwaiter',
    'Eat In Kitchen',
    'Electric Dryer Hookup',
    'Elevator',
    'Full Bath',
    'Galley Type Kitchen',
    'Garden Tub',
    'Gas Dryer Hookup',
    'Gourmet Kitchen',
    'Half Bath',
    'High Ceilings',
    'Jetted Tub',
    'Kitchenette',
    'Laundry Chute',
    'Laundry Sink',
    'Low Flow Plumbing Fixtures',
    'Low/No VOC',
    'Multiple Laundry Machines',
    'Murphy Bed',
    'Natural Woodwork',
    'None',
    'Open to Family Room',
    'Pantry',
    'Plumbed for Icemaker',
    'Pocket Doors',
    'Primary Bedroom Dressing Room',
    'Primary Bedroom Sitting/Study Room',
    'Recessed Lighting',
    'Sauna',
    'Second Primary Bedroom (no input)',
    'See Remarks',
    'Separate Shower',
    'Shared Bath',
    'Smart Home',
    'Smart Thermostat',
    'Soaking Tub',
    'Solar Tube(s)',
    'Sound System',
    'Stackable W/D Connections',
    'Steam Shower',
    'Storage',
    'Track Lighting',
    'Tray Ceiling(s)',
    'Two Primary Closets',
    'Vaulted Ceiling(s)',
    'Walk-In Closet(s)',
    'Walk-in Shower',
    'Washer Hookup',
    'WaterSense Fixture(s)',
    'Wet Bar',
    'Wired for Data',
    'Wired for Sound'
];
